import { combineReducers } from 'redux'
import authReducer from './authReducer'
import customerReducer from './customers/customerReducer';
import roleReducer from './roles/roleReducer';
import userAdminReducer from './userAdmin/userAdminReducer';
import distributorReducer from './distributors/distributerReducer'
import configurationReducer from './/configuration/configurationReducer'
import receiptTemplateReducer from './receipt-templates/receiptTemplatesReducer'
import FranchiseReducer from './franchise/franchiseReducer'
import groupMappingReducer from './group-mapping/groupMappingReducer'
import heartBeatReducer from './heartBeatReducer/heartBeatReducer'
import copyMenuReducer from './copy-menu/copyMenuReducer'
const reducer = {
    auth: authReducer,
    customerReducer,
    roleReducer,
    userAdminReducer,
    distributorReducer,
    configurationReducer,
    receiptTemplateReducer,
    FranchiseReducer,
    groupMappingReducer,
    heartBeatReducer,
    copyMenuReducer
}
const appReducer = combineReducers(reducer);


const rootReducer = (state, action) => {
    if (action.type === 'auth/logout/fulfilled') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}


export default rootReducer;
// export default combineReducers(reducer);

export function CLEARSTORE() {
    return {
        type: "CLEARSTORE"
    };
}
